module.exports = __webpack_public_path__ + "img/fund-step7.c03edeaa.png";